import { permissionsRol as collectionRol } from 'app/policies/roles/collectionsRol.access';
import { PATH_COLLECTION, PATH_COLLECTIONS, PATH_COLLECTION_CREATE } from 'app/router/routesConfigCollections';

export function collections(path, user) {
  if (PATH_COLLECTION === path) {
    return collectionRol(user).readDetail;
  }

  if (PATH_COLLECTIONS === path) {
    return collectionRol(user).readList;
  }

  if (PATH_COLLECTION_CREATE === path) {
    return collectionRol(user).create;
  }

  return true;
}
